import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from '../axios-default';
import { SET_QUESTIONS } from '../store/DiffRetainers/actionType';
import useAuth from './useAuth';

const useRetainerRequestQuestions = (isFetchRetainerRelatedData = false) => {
    const dispatch = useDispatch();
    const auth = useAuth();

    useEffect(() => {
        if (auth.user && auth.user.user_id && isFetchRetainerRelatedData) {
            const fetchQuestionOptions = async () => {
                const res = await axios.get(`retainerType/retainer_request_caseOpt`);
                if (res.status === 200 && res.data && res.data.option) {
                    dispatch({ type: SET_QUESTIONS, payload: res.data.option });
                }
            };
            fetchQuestionOptions();
        }
    }, [auth.user, dispatch, isFetchRetainerRelatedData]);
};

export default useRetainerRequestQuestions;
